module.exports = __webpack_public_path__ + "img/3.bdfbec08.png";